import { useLocalStorage } from '@uidotdev/usehooks';
import { createContext, ReactNode, useCallback, useMemo } from 'react';

// project import
import config from 'config';

// types
import { CustomizationProps } from 'types/config';

// initial state
const initialState: CustomizationProps = {
    ...config,
    onChangeContainer: () => {},
    onChangeMiniDrawer: () => {},
};

// ==============================|| CONFIG CONTEXT & PROVIDER ||============================== //

const ConfigContext = createContext(initialState);

type ConfigProviderProps = {
    children: ReactNode;
};

function ConfigProvider({ children }: ConfigProviderProps): JSX.Element {
    const [config, setConfig] = useLocalStorage('mantis-react-ts-config', initialState);

    const onChangeContainer = useCallback(() => {
        setConfig((prev) => ({
            ...prev,
            container: !prev.container,
        }));
    }, [setConfig]);

    const onChangeMiniDrawer = useCallback(
        (miniDrawer: boolean) => {
            setConfig((prev) => ({
                ...prev,
                miniDrawer,
            }));
        },
        [setConfig]
    );

    const value = useMemo(
        () => ({
            ...config,
            onChangeContainer,
            onChangeMiniDrawer,
        }),
        [config, onChangeContainer, onChangeMiniDrawer]
    );

    return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
}

export { ConfigContext, ConfigProvider };
